import React, { FC } from 'react';
import styled from 'styled-components';
import { colors } from 'styles/colors';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { Text } from 'components/text/Text';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { MainLayout } from 'src/pages-all/master-page/components/main-layout';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import { SubSectionHeadline } from 'src/pages-all/home/components/parts/default.parts';
import { bodyFontSize } from '../home.page.const';
import { AppRoute } from 'app/app.route.const';
import { ActionButton } from './ActionButton';
import { navigationSlice } from '../../../logic/store/navigation/navigation.slice';
import { useDispatch } from 'react-redux';
import { useLocalizedI18nGlobal } from '../../../logic/translations/use-localized-i18n-global';

const SectionContainer = styled(MainLayout)<any>`
  padding: 60px 24px 80px 24px;
  background-color: ${colors.lightTeal};
  background-image: ${({ minTablet, showBackGroundImage }) =>
    minTablet && showBackGroundImage ? "url('/images/brandenburger-tor-ukraine.jpg')" : ''};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
`;

export const TextGridBox = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 330px));
  gap: 20px;
  place-items: center;
  justify-content: center;
`;

const Description = styled.div`
  display: flex;
  padding: 24px 0 0 0;
  margin: 0 auto;
  justify-content: center;
`;

export const AlternativeConsulting: FC = () => {
  useLocalizedI18nGlobal();
  const { min500, maxMobileLarge, minTablet } = useBreakpoints();
  const dispatch = useDispatch();

  return (
    <SectionContainer min500={min500} minTablet={minTablet} id={'spendeninitative'}>
      <MainContent>
        <SubSectionHeadline
          headline={translate(
            translationKeys.searchResultsPage.common.otherTutoringOptions.premium.title
          )}
          center
          style={{ margin: '0 auto', padding: 0 }}
        >
          <Description>
            <Text
              size={bodyFontSize(maxMobileLarge)}
              color={'blueGray'}
              fontWeight={600}
              textAlign={'center'}
            >
              {translate(
                translationKeys.searchResultsPage.common.otherTutoringOptions.premium.subTitle
              )}
            </Text>
          </Description>
          <ActionButton
            style={{ margin: '24px auto 0 auto', minWidth: min500 ? '300px' : undefined }}
            onClick={() =>
              dispatch(
                navigationSlice.actions.navigateTo({
                  path: AppRoute.External_TrialHour_Search_Bottom,
                })
              )
            }
          >
            {translate(
              translationKeys.searchResultsPage.common.otherTutoringOptions.premium.button
            )}
          </ActionButton>
        </SubSectionHeadline>
      </MainContent>
    </SectionContainer>
  );
};
